import { Link, useLocation } from "react-router-dom";

const HeroAbout = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: "/about/vision", label: "경영이념" },
    { path: "/about/history", label: "연혁" },
    { path: "/about/technology", label: "보유기술 및 특허" },
    { path: "/about/clients", label: "주요 고객사" },
    { path: "/about/location", label: "오시는 길" },
  ];

  return (
    <div className="w-full max-w-full py-8 bg-gradient-to-l mt-20">
      <section className="flex flex-col items-start justify-between mx-auto border-b max-w-container about:flex-row about:items-end">
        <div className="hidden sm:block mb-[2rem] text-black px-[2rem] wide:px-0 about:mb-[2rem]">
          <h1
            className="text-left leading-[1.3] flex flex-col"
            style={{ fontSize: "var(--font-display-large, 5rem)", fontWeight: 700 }}
          >
            <span className="text-[2.2rem] font-medium">회사 소개</span>
            <span className="text-[4rem] font-bold">
              {navItems.find(item => item.path === currentPath)?.label}
            </span>
          </h1>
        </div>

        {/* 네비게이션 영역: 모바일에서도 가로 스크롤로 유지 */}
        <nav aria-label="회사 소개 메뉴" className="w-full about:w-auto px-[2rem] wide:px-0">
          <ul className="flex items-center gap-2 m-0 list-none overflow-x-auto whitespace-nowrap scrollbar-hide overscroll-x-contain about:gap-4 about:overflow-visible">
            {navItems.map(item => (
              <li key={item.path} className="flex shrink-0">
                <Link
                  to={item.path}
                  className="relative inline-block pb-4 pr-4 transition-colors about:px-5"
                  style={{
                    fontSize: "var(--font-title-medium, 1.8rem)",
                    color: currentPath === item.path ? "#032C6D" : "#888",
                    fontWeight: currentPath === item.path ? 700 : 400,
                  }}
                >
                  {item.label}
                  {currentPath === item.path && (
                    <span className="absolute left-0 bottom-0 h-[2px] bg-[#032C6D] w-full" />
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </section>

      {/* 스크롤바 숨김 스타일 */}
      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>
  );
};

export default HeroAbout;
